import {FaUserCircle, FaBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
////import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";
import CatalogOptions from "../components/CatalogOptions";

export default function Header({ toggleSidebar }) {
  const notificationRef = useRef(null);
 // const hasFetched = useRef(false);
  const navigate = useNavigate();
  const userName = sessionStorage.getItem("userName");
  const [showNotifications, setShowNotifications] = useState(false);
const [notifications] = useState([
  {
    id: 1,
    title: "Attendance Alert",
    message: "You marked attendance late today",
    time: "5 mins ago"
  },
  {
    id: 2,
    title: "Fee Reminder",
    message: "Student Ravi has pending fee",
    time: "1 hour ago"
  },
  {
    id: 3,
    title: "New Student Admission",
    message: "New student joined Class 10A",
    time: "Today"
  }
]);

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  //const [years, setYears] = useState([]);
  const [loading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    sessionStorage.getItem("academicYearId") || ""
  );
  // if (!hasFetched.current) {
  //   if(selectedYear){
  //        hasFetched.current = true;
  //   }
  //   const allCatalogs = JSON.parse(sessionStorage.getItem("cacheCatalogs") || "[]");
  //   const activeYear = allCatalogs?allCatalogs.find(c => c.catalogName === "AcademicYear"):{};
  //   if(activeYear){
  //       activeYear.entries.length > 0? setYears(activeYear.entries): setYears([]);
  //   }

  // }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      } 
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleYearChange = (field,value) => {
    const yearId = value;//e.target.value;

    setSelectedYear(yearId);
    sessionStorage.setItem("academicYearId", yearId);
    // reload current URL with new ID
    const currentUrl = window.location.href;
    // navigate to updated URL
    window.location.href = currentUrl.toString();
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/login", { replace: true });
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-blue-700 text-white p-4 flex justify-between items-center relative">
      
      {/* LEFT SIDE */}
      <div className="flex items-center gap-4">
         {loading && <Loader />}
        {/* Hamburger only mobile */}
        <button onClick={toggleSidebar} className="md:hidden">
          <FaUserCircle  size={30} />
        </button>

        {/* Logo */}
        <img
          src="/Avyb_Web_Logo.png"
          alt="School Logo"
          className="h-10 md:h-12 w-auto rounded hidden md:block"
        />

        {/* School Name */}
        <h1 className="hidden md:block text-lg font-semibold">
          AVYB Technologies
        </h1>
      </div>

     {/* RIGHT SIDE */}
      <div className="flex items-center gap-4">

        {/* <select
          value={selectedYear || ""}
          onChange={handleYearChange}
          className="border border-gray-300 rounded px-2 py-1 bg-white text-black text-sm hidden md:block"
        >
         {years.length>0?(years
         // .filter(entry => entry.active) // only active entries
          .map(entry => (
            <option key={entry.id} value={entry.code}>
              {entry.name}
            </option>
          ))):[]
        }
        </select> */}
       <CatalogOptions
                      name="selectedYear"
                      value={selectedYear}
                      catalogName="AcademicYear"
                      onChange={handleYearChange}
                      className="border border-gray-300 rounded px-2 py-1 bg-white text-black text-sm hidden md:block" 
                    />


        {/* Welcome Text */}
        <span className="hidden md:block text-sm font-bold">
          Welcome {userName}
        </span>

        {/* Alert Icon */}
       <div className="relative">
          <button
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative hover:text-gray-200"
          >
            <FaBell size={20} />

            {notifications.length > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1 rounded-full">
                {notifications.length}
              </span>
            )}
          </button>

          {showNotifications && (
            <div
              ref={notificationRef}
              className="absolute right-0 mt-3 w-80 max-w-[90vw] bg-white text-black rounded-lg shadow-lg z-50"
            >
              <div className="p-3 border-b font-bold">
                Notifications
              </div>

              <div className="max-h-80 overflow-y-auto">

                {notifications.map((note) => (
                  <div
                    key={note.id}
                    className="p-3 border-b hover:bg-gray-100 text-sm"
                  >
                    <p className="font-semibold">{note.title}</p>
                    <p className="text-gray-600">{note.message}</p>
                    <span className="text-xs text-gray-400">
                      {note.time}
                    </span>
                  </div>
                ))}

              </div>

            </div>
          )}
        </div>
        {/* Profile Section */}
        <div className="relative hidden md:block" ref={dropdownRef}>
          <button
            onClick={() => setOpen(!open)}
            className="hover:text-gray-200"
          >
            <FaUserCircle size={26} />
          </button>

          {open && (
            <div className="absolute right-4 top-12 bg-white font-bold text-black rounded shadow-lg z-50 w-40">

              <button
                onClick={handleProfile}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
              >
                Profile
              </button>

              <button
                onClick={handleLogout}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
              >
                Logout
              </button>

            </div>
          )}

        </div>

      </div>
    </header>
  );
}